import { AdaptiveDpr, PerformanceMonitor } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import { Component, type ErrorInfo, type ReactNode, Suspense, useState } from 'react';
import { ExchangeWorld } from './ExchangeWorld';

class CanvasBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('WebGL scene failed', error, info);
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="webgl-fallback">
          <img src="/assets/concept/exchange-district.png" alt="Corrupted exchange district" />
          <div>
            <strong>YOUR GPU GOT RUGGED.</strong>
            <span>The 2D controls still work. The monsters are judging your graphics card.</span>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export function WorldCanvas() {
  const [dpr, setDpr] = useState(1.25);

  return (
    <CanvasBoundary>
      <Canvas
        className="world-canvas"
        dpr={dpr}
        shadows
        camera={{ position: [4.8, 5.4, 11], fov: 46, near: 0.1, far: 50 }}
        gl={{ antialias: true, powerPreference: 'high-performance' }}
      >
        <PerformanceMonitor
          onIncline={() => setDpr(1.5)}
          onDecline={() => setDpr(1)}
          flipflops={3}
        />
        <AdaptiveDpr pixelated />
        <Suspense fallback={null}>
          <ExchangeWorld />
        </Suspense>
      </Canvas>
    </CanvasBoundary>
  );
}

